import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';

export default function VentasTable({ ventas, onEdit, onAnular }) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Fecha</TableCell>
          <TableCell>Cliente</TableCell>
          <TableCell>Monto</TableCell>
          <TableCell>Estado</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>

      <TableBody>
        {ventas.map(v => (
          <TableRow
            key={v.id}
            sx={{
              textDecoration: v.estado === 'ANULADA' ? 'line-through' : 'none',
              opacity: v.estado === 'ANULADA' ? 0.5 : 1
            }}
          >
            <TableCell>{v.fecha}</TableCell>
            <TableCell>{v.cliente}</TableCell>
            <TableCell>{v.monto}</TableCell>
            <TableCell>{v.estado}</TableCell>
            <TableCell>
              <IconButton onClick={() => onEdit(v)}>
                <EditIcon />
              </IconButton>

              {v.estado === 'ACTIVA' && (
                <IconButton
                  color="error"
                  onClick={() => {
                    const motivo = prompt('Motivo de anulación');
                    if (motivo) onAnular(v.id, motivo);
                  }}
                >
                  <CancelIcon />
                </IconButton>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
